import SubMenu from "./SubMenu";

const Sidebar = () => {
  return (
    <div className="w-full rounded-2xl">
      <SubMenu />
    </div>
  );
};

export default Sidebar;
